import { __decorate, __param } from 'vscode/external/tslib/tslib.es6.js';
import { IClipboardService } from 'vscode/vscode/vs/platform/clipboard/common/clipboardService.service';
import { IDialogService } from 'vscode/vscode/vs/platform/dialogs/common/dialogs.service';
import { IKeybindingService } from 'vscode/vscode/vs/platform/keybinding/common/keybinding.service';
import { ILayoutService } from 'vscode/vscode/vs/platform/layout/browser/layoutService.service';
import { ILogService } from 'vscode/vscode/vs/platform/log/common/log.service';
import { IProductService } from 'vscode/vscode/vs/platform/product/common/productService.service';
import { registerWorkbenchContribution2 } from 'vscode/vscode/vs/workbench/common/contributions';
import { BrowserDialogHandler } from './dialogHandler.js';
import { Disposable } from 'vscode/vscode/vs/base/common/lifecycle';
import { IInstantiationService } from 'vscode/vscode/vs/platform/instantiation/common/instantiation';
import { Lazy } from 'vscode/vscode/vs/base/common/lazy';

let DialogHandlerContribution = class DialogHandlerContribution extends Disposable {
    static { this.ID = 'workbench.contrib.dialogHandler'; }
    constructor(dialogService, logService, layoutService, keybindingService, instantiationService, productService, clipboardService) {
        super();
        this.dialogService = dialogService;
        this.impl = ( new Lazy(() => ( new BrowserDialogHandler(
            logService,
            layoutService,
            keybindingService,
            instantiationService,
            productService,
            clipboardService
        ))));
        this.model = this.dialogService.model;
        this._register(this.model.onWillShowDialog(() => {
            if (!this.currentDialog) {
                this.processDialogs();
            }
        }));
        this.processDialogs();
    }
    async processDialogs() {
        while (this.model.dialogs.length) {
            this.currentDialog = this.model.dialogs[0];
            let result = undefined;
            try {
                if (this.currentDialog.args.confirmArgs) {
                    const args = this.currentDialog.args.confirmArgs;
                    result = await this.impl.value.confirm(args.confirmation);
                }
                else if (this.currentDialog.args.inputArgs) {
                    const args = this.currentDialog.args.inputArgs;
                    result = await this.impl.value.input(args.input);
                }
                else if (this.currentDialog.args.promptArgs) {
                    const args = this.currentDialog.args.promptArgs;
                    result = await this.impl.value.prompt(args.prompt);
                }
                else {
                    await this.impl.value.about();
                }
            }
            catch (error) {
                result = error;
            }
            this.currentDialog.close(result);
            this.currentDialog = undefined;
        }
    }
};
DialogHandlerContribution = ( __decorate([
    ( __param(0, IDialogService)),
    ( __param(1, ILogService)),
    ( __param(2, ILayoutService)),
    ( __param(3, IKeybindingService)),
    ( __param(4, IInstantiationService)),
    ( __param(5, IProductService)),
    ( __param(6, IClipboardService))
], DialogHandlerContribution));
registerWorkbenchContribution2(DialogHandlerContribution.ID, DialogHandlerContribution, 1 );

export { DialogHandlerContribution };
